<div class="card card-tabs">
	<div class="card-body">
		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<label for="" class="title-history">
				Carga DTE
			</label>

			<input type="radio" name="pcss3t" [(ngModel)]="history" [value]="0" checked id="tab1">
			<label for="tab1">
				<i class="fa fa-file"></i>Carga de Documentos
			</label>

			<input type="radio" name="pcss3t" [(ngModel)]="history" [value]="1" id="tab2" class="tab-content-2">
			<label for="tab2">
				<i class="fa fa-calendar"></i>Histórico
			</label>

			<input type="radio" name="pcss3t" [(ngModel)]="history" [value]="2" id="tab3" class="tab-content-3">
			<label for="tab3">
				<i class="fa fa-right-left"></i>Conciliación
			</label>
		</div>
	</div>
	<app-history-dte *ngIf="history == 1"></app-history-dte>
	<app-upload-new-dte *ngIf="history == 0"></app-upload-new-dte>
	<app-reconciliation-report *ngIf="history == 2"></app-reconciliation-report>
</div>